import client from "./client.js";

export const fetchInboundWebhooks = () =>
  client.get("/inbound-webhooks").then((r) => r.data.data);

export const createInboundWebhook = (payload) =>
  client.post("/inbound-webhooks", payload).then((r) => r.data.data);

export const updateInboundWebhook = (id, payload) =>
  client.patch(`/inbound-webhooks/${id}`, payload).then((r) => r.data.data);

export const deleteInboundWebhook = (id) =>
  client.delete(`/inbound-webhooks/${id}`);

export const rotateInboundWebhookToken = (id) =>
  client.post(`/inbound-webhooks/${id}/rotate`).then((r) => r.data.data);

export const fetchInboundWebhookEvents = (id, limit = 20) =>
  client
    .get(`/inbound-webhooks/${id}/events`, { params: { limit } })
    .then((r) => r.data.data);
